import ProxyBase from '../../../../../../core/proxies/ProxyBase'

export class BusinessYearsProxy extends ProxyBase {
  getBusinessYearsTable(params) {
    return this.get('YearOfOperation', params)
  }
  exportBusinessYears(params) {
    return this.post('YearOfOperation/Export', params, {}, 'download')
  }
}

export default new BusinessYearsProxy('IndustryOverview/')
